import React from 'react';
import { Dropdown, Avatar, Icon } from '../';

const DropdownUser = ({
  session,
  onClick
}) => {
  const { user, accounts } = session
  const currentAccount = accounts[0]

  return (<Dropdown
    align="right"
    className="dropdown-user"
    button={<>
      <div className="dropdown-user-name">
        {user.name}
        {currentAccount &&
          <div className="dropdown-user-account">
            {currentAccount?.name}
          </div>
        }
      </div>
      <Avatar placeholder={user.name[0] || user.email[0]} />
    </>}
    onClick={onClick}
    variant="icon"
  >
    <Dropdown.Item to={'/dashboard/account'}>
      <Icon id="icon-tune" className="me-1" size="20" />
      Minha conta
    </Dropdown.Item>
    {/* <Dropdown.Item to={'#'}>
      <Icon id="icon-person" className="me-1" size="20" />
      Pagamentos
    </Dropdown.Item> */}
    <Dropdown.Item to={'/dashboard/account/workspaces'}>
      <Icon id="icon-workspace" className="me-1" size="20" />
      Workspaces
    </Dropdown.Item>
    <Dropdown.Item to={'/logout'}>
      <Icon id="icon-exit" className="me-1" size="20" />
      Sair
    </Dropdown.Item>
  </Dropdown>)
}

export default DropdownUser;
